<template>
	<ViewLayout className="cam-front-check">
		<template v-slot:cam>
			<CapturedImage :image="image" :overlay="overlay" />
		</template>
		<template v-slot:body>
			<CamBreadcrumb :index="0" />
			<h2 v-if="$store.strings.camera_frontCheck && $store.strings.camera_frontCheckTitle">{{ $store.strings.camera_frontCheckTitle }}</h2>
			<p v-for="check of $store.strings.camera_frontCheck.split('\n')" :key="check"><span class="question-bubble">{{ check }}</span></p>
			<div class="spacer"></div>
		</template>
		<template v-slot:footer>
			<div class="uk-button-group">
				<router-link to="cam-front">
					<button class="uk-button uk-button-primary uk-button-large matomo-button-no" onclick="_paq.push(['trackEvent', 'cam_front_check', false]);">
						<i uk-icon="icon: close"></i>
					</button>
				</router-link>
				<router-link to="cam-side">
					<button class="uk-button uk-button-primary uk-button-large matomo-button-yes" onclick="_paq.push(['trackEvent', 'cam_front_check', true]);">
						<i uk-icon="icon: check"></i>
					</button>
				</router-link>
			</div>
		</template>
	</ViewLayout>
</template>

<script>
import ViewLayout from '@/components/ViewLayout.vue'
import CamBreadcrumb from '@/components/CamBreadcrumb.vue'
import CapturedImage from '@/components/CapturedImage.vue'
import Overlay from '@/assets/cam-overlay-front.svg'

export default {
	name: 'CamFrontCheck',
	components: {
		ViewLayout,
		CamBreadcrumb,
		CapturedImage,
	},
	data: function() {
		return {
			image: this.$store.request.images.front,
			overlay: Overlay,
		};
	},
	mounted: function() {
		if (!this.$store.request.images.front)
			this.$router.push('/')
	},
	created: function() {
		if (
			!this.$store.request ||
			this.$store.request.cistern === null ||
			!this.$store.request.images.front
		) {
			this.$router.push('/')
		}
	},
}
</script>
